import React, { useEffect } from 'react';
import './KodanshaNewsWheel.scss';
import KodanshaNewsWheelItem from './KodanshaNewsWheelItem';
import { Swiper, SwiperSlide } from 'swiper/react';
import { FreeMode } from 'swiper';
import { useAtomValue, useSetAtom } from 'jotai';
import { FetchNewsArticlesAtom, NewsArticlesAtom } from '../../store/NewsArticleStore';
import Log from '../Services/Logger';

interface KodanshaNewsWheelProps {
    title: string;
    count?: number;
}


export function KodanshaNewsWheel(props: KodanshaNewsWheelProps): JSX.Element {
    const count = props.count ?? 3;
    const articles = useAtomValue(NewsArticlesAtom);
    const fetchArticles = useSetAtom(FetchNewsArticlesAtom);

    useEffect(() =>{
        fetchArticles(count).then(() => Log.debug(`${count} news articles fetched.`));
    }, []);

    Log.debug("Render News Wheel");

    return (
        <section aria-label={'news wheel item'} className={'KodanshaNewsWheelHomePage'}>
            <div className={'wheel-title'}>{props.title}</div>

            <Swiper
                spaceBetween={15}
                slidesPerView={2}
                slidesPerGroup={2}
                freeMode={true}
                modules={[FreeMode]}
                navigation={{
                    prevEl: '.prev',
                    nextEl: '.next',
                }}
                breakpoints={{
                    320: {
                        slidesPerView: 1.2,
                        slidesPerGroup: 1,
                    },
                    480: {
                        slidesPerView: 1.4,
                        slidesPerGroup: 1,
                    },
                    576: {
                        slidesPerView: 1.7,
                        slidesPerGroup: 1,
                    },
                    768: {
                        slidesPerView: 3,
                        slidesPerGroup: 3,
                    },
                }}
            >
                {articles.slice(0,count).map((article) => {
                    return <SwiperSlide key={article.id}>
                        <div className='ItemContainerHomePage'>
                            <KodanshaNewsWheelItem
                                date={new Date(article.publishDate).toDateString()}
                                src={article.thumbnails[0]?.url}
                                title={article.title}
                                description={article.summary}
                                url={article.readableUrl}
                            />
                        </div>
                    </SwiperSlide>;
                })}
            </Swiper>
        </section>
    );
}
